/**
 * Настройки сборки фронта.
 *
 * Домен компании — параметр, а не константа: боевое значение подставляет заказчик
 * при развёртывании, в исходниках его нет. Фронту домен нужен только для подсказки
 * и для блокировки кнопки на экране входа; настоящая проверка всё равно на сервере,
 * и расхождение значений не создаёт дыру, а лишь портит подсказку.
 */
export const ALLOWED_DOMAIN: string = import.meta.env.VITE_ALLOWED_DOMAIN ?? 'test.ru'

export function isAllowedEmail(email: string): boolean {
  const value = email.trim().toLowerCase()
  // Проверка нарочно грубая: точный разбор адреса — работа сервера.
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && value.endsWith('@' + ALLOWED_DOMAIN)
}
